import { useRef, useEffect, useState } from "react";

const SvgMarquee = ({
    text = "AVISO DE VOLADURA",
    width = 500,
    height = 100,
    bgColor = "#111",
    strokeColor = "#000000",
    strokeWidth = 0,
    fill = "#ff0000",
    fontSize = 32,
    fontFamily = "Poppins, sans-serif",
    weight = 700,
    speed = 200,
    x = 0,
    y = 0,
    transform = 0.82, 
    ...props
}) => {
    const textRef = useRef(null);
    const [textLength, setTextLength] = useState(0);
    const [xPath, setxPath] = useState(width);
    const scaleX = parseFloat(transform.match(/scale\(([^,]+),/)[1]);

    useEffect(() => {
        if (textRef.current) {
            const rawLength = textRef.current.getComputedTextLength();
            setTextLength(rawLength * scaleX); // 👈 se aplica la escala aquí
        }
    }, [text, scaleX]);

    useEffect(() => {
        if (textLength <= width) return;

        let frameId;
        let lastTime = performance.now();

        const animate = (time) => {
            const delta = (time - lastTime) / 1000; // segundos
            lastTime = time;

            setxPath((prevX) => {
                const nextX = prevX - speed * delta;
                return nextX < -textLength ? width : nextX;
            });

            frameId = requestAnimationFrame(animate);
        };

        frameId = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(frameId);
    }, [speed, textLength, width]);

    const textX = textLength <= width ? (width - textLength) / 2 : xPath;

    return (
        <svg
            viewBox={`0 0 ${width} ${height}`}
            width={width}
            height={height}
            x={x}
            y={y} // 79.186-7.2727
        >
            <rect
                x="0"
                y="0"
                width={width}
                height={height}
                fill={bgColor}
            />
            <text
                ref={textRef}
                x={0} //AL MEDIO : textX / scaleX
                y={(height / 2) + 40}
                fill={fill}
                fontSize={fontSize}
                fontFamily={fontFamily}
                dominantBaseline="middle"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
                fontWeight={weight}
                transform={transform} // 👈 escala horizontal
            >
                {text}
            </text>
        </svg>
    );
};

export default SvgMarquee;
